export type ScheduleQueryParams = {
  plantId: string
  start: string
  end: string
}

export type OptimizedScheduleQueryParams = {
  plantId: string
}

export type CostAvoidanceMonthlyParams = {
  plantId: string
  fromYearMonth: string
  toYearMonth: string
}

export type CostAvoidanceDailyParams = {
  plantId: string
  fromDay: string
  toDay: string
}

export const getSchedulePath = (): string => '/schedules/current'

export const getOptimizedSchedulesPath = (plantId: string): string =>
  `/plants/${plantId}/schedules/optimized`

export const getOptimizedScheduleStatsPath = (plantId: string): string =>
  `/plants/${plantId}/schedules/optimized/stats`

export const getCostAvoidanceMonthlyPath = (plantId: string): string =>
  `/plants/${plantId}/schedules/kpi/cost-avoidance/monthly`

export const getCostAvoidanceDailyPath = (plantId: string): string =>
  `/plants/${plantId}/schedules/kpi/cost-avoidance`

export const getCostAvoidanceForRangePath = (plantId: string, scheduleId: number): string =>
  `/plants/${plantId}/schedules/${scheduleId}/kpi/cost-avoidance-for-range`
